import { useEffect, useState } from "react";
import { Cpu } from "lucide-react";
import { api } from "@/lib/api";
import { Section } from "@/components/duitku/shared";

const fmt = (n) => new Intl.NumberFormat("id-ID").format(Math.round(n || 0));

const Row = ({ label, value, max, testid }) => (
  <div data-testid={testid}>
    <div className="flex justify-between text-xs text-gray-500 mb-1"><span>{label}</span><span>{fmt(value)}</span></div>
    <div className="h-2 rounded-full bg-pink-50 overflow-hidden"><div className="h-full bg-sky-300 rounded-full" style={{ width: `${Math.min(100, (value / (max || 1)) * 100)}%` }} /></div>
  </div>
);

export const TokenUsage = () => {
  const [u, setU] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/ai/usage").then((r) => setU(r.data)).catch(() => setErr(true)); }, []);
  if (err) return <p className="text-sm text-rose-500" data-testid="ai-usage-error">Gagal memuat pemakaian AI.</p>;
  if (!u) return <div className="h-32 rounded-3xl bg-pink-100/60 animate-pulse" />;
  const pct = Math.min(100, (u.used / u.limit) * 100);
  const tone = pct >= 90 ? "bg-rose-400" : pct >= 70 ? "bg-amber-400" : "bg-pink-400";
  return (
    <Section title={<span className="flex items-center gap-2"><Cpu className="w-5 h-5 text-violet-400" /> Pemakaian AI bulan ini</span>}>
      <div className="flex items-end justify-between mb-2">
        <p className="font-heading text-2xl font-semibold text-gray-800" data-testid="ai-usage-used">{fmt(u.used)} <span className="text-sm text-gray-400 font-body">/ {fmt(u.limit)} token</span></p>
        <span className="text-sm font-semibold text-pink-500" data-testid="ai-usage-percent">{pct.toFixed(1)}%</span>
      </div>
      <div className="h-4 rounded-full bg-pink-50 overflow-hidden" data-testid="ai-usage-bar">
        <div className={`h-full ${tone} rounded-full transition-all`} style={{ width: `${pct}%` }} />
      </div>
      <p className="text-xs text-gray-400 mt-2">Sisa {fmt(Math.max(0, u.limit - u.used))} token · kuota direset tiap awal bulan. Kalau habis, fitur AI berhenti sampai bulan depan.</p>
      {Object.keys(u.by_feature).length > 0 && (
        <div className="grid sm:grid-cols-2 gap-x-6 gap-y-3 mt-4">
          {Object.entries(u.by_feature).map(([k, v]) => <Row key={k} label={k} value={v} max={u.used} testid={`ai-usage-feature-${k}`} />)}
          {Object.entries(u.by_user).map(([k, v]) => <Row key={k} label={`Dipakai ${k}`} value={v} max={u.used} testid={`ai-usage-user-${k}`} />)}
        </div>
      )}
    </Section>
  );
};
